import { Component, OnInit } from '@angular/core';
import { News, TeamMember } from '../../../classes/classes';
import { NewsService } from '../../../services/news.service';
import { TeamsService } from '../../../services/teams.service';

declare let google: any;

@Component({
  selector: 'app-d-risk',
  templateUrl: './d-risk.component.html',
  styleUrls: ['./d-risk.component.sass']
})
export class DRiskComponent implements OnInit {
  public _teamMembers: TeamMember[] = [];

  public selectedSlice: any = 0;

  public selectedTab = 'expl';

  constructor(private _teamService: TeamsService, private _newsService: NewsService) {
    this._teamMembers = this._teamService.get_tm_drisk();
  }

  public ngOnInit() {
    this.generateWheel(this.displayContent, this);
  }

  onResize(event) {
    this.generateWheel(this.displayContent, this);
  }

  // fixes bug onPageChange
  public ngOnDestroy() {
    this._teamMembers.forEach(m => {
      m.isActive = false;
    });
  }

  // wheel - functions
  public displayContent(value: any, context: any): any {
    context.selectedSlice = value;
    context.selectedTab = 'expl'; // this will reset the active tab on select
  }

  public generateWheel(fn, ctx) {
    const stringsArray = ['D-Risk Lending', 'Climate-Related Financial Risk', 'Risk Assessment'];
    const perc = stringsArray.length * 360 / 100;
    const dataArray = [];

    dataArray.push(['Service Name', 'Slice Size']);
    for (let i = 0; i < stringsArray.length; i++) {
      const a = [stringsArray[i], perc];
      dataArray.push(a);
    }

    const slicesColour = {};
    for (let i = 0; i < stringsArray.length; i++) {
      slicesColour[i] = { color: 'darkblue', offset: 0.0 };
    }

    // Load the Visualization API and the corechart package.
    google.charts.load('current', { 'packages': ['corechart'] });

    // Set a callback to run when the Google Visualization API is loaded.
    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {
      let chart, data, options;
      data = google.visualization.arrayToDataTable(dataArray);
      options = {
        animation: {
          duration: 800,
          easing: 'out'
        },
        pieHole: 0.4,
        legend: 'none',
        pieSliceText: 'label',
        tooltip: { trigger: 'none' },
        slices: slicesColour,
        pieSliceTextStyle: {
          color: '#fff',
          fontSize: 16
        },
        chartArea: { top: 80, left: 15, right: 15 },
        enableInteractivity: true
      };

      chart = new google.visualization.PieChart(document.getElementById('piechart'));

      google.visualization.events.addListener(chart, 'ready', function () {
        chart.setSelection([{ row: 0 }]);
        addChartGradient(chart);
      });

      google.visualization.events.addListener(chart, 'onmouseover', function () {
        addChartGradient(chart);
      });

      google.visualization.events.addListener(chart, 'onmouseout', function () {
        addChartGradient(chart);
      });

      google.visualization.events.addListener(chart, 'select', function () {
        addChartGradient(chart);
        if (chart.getSelection()[0]) {
          fn(chart.getSelection()[0].row, ctx);
        }
      });

      chart.draw(data, options);

      function addChartGradient(chart) {
        const chartDiv = chart.getContainer();
        const svg = chartDiv.getElementsByTagName('svg')[0];
        const properties = {
          id: 'chartGradient',
          x1: '100%',
          y1: '0%',
          x2: '0%',
          y2: '100%',
          stops: [
            { offset: '0%', 'stop-color': '#044080' },
            { offset: '100%', 'stop-color': '#011833' }
          ]
        };

        createGradient(svg, properties);

        svg.getElementsByTagName('rect')[0].setAttribute('fill', 'transparent');

        for (let i = 0; i < stringsArray.length; i++) {
          svg.getElementsByTagName('g')[i].getElementsByTagName('path')[0].setAttribute('fill', 'url(#chartGradient)');
          if (svg.getElementsByTagName('g')[i].getElementsByTagName('path')[1]) {
            svg.getElementsByTagName('g')[i].getElementsByTagName('path')[1].setAttribute('stroke', '#044080');
            svg.getElementsByTagName('g')[i].getElementsByTagName('path')[1].setAttribute('stroke-width', '4');
            if (svg.getElementsByTagName('g')[i].getElementsByTagName('path')[2]) {
              svg.getElementsByTagName('g')[i].getElementsByTagName('path')[2].setAttribute('stroke', '#044080');
            }
          }
        }
      }

      function createGradient(svg, properties) {
        const svgNS = svg.namespaceURI;
        const grad = document.createElementNS(svgNS, 'linearGradient');
        grad.setAttribute('id', properties.id);
        ['x1', 'y1', 'x2', 'y2'].forEach(function (name) {
          if (properties.hasOwnProperty(name)) {
            grad.setAttribute(name, properties[name]);
          }
        });
        for (let i = 0; i < properties.stops.length; i++) {
          const attrs = properties.stops[i];
          const stop = document.createElementNS(svgNS, 'stop');
          for (const attr in attrs) {
            if (attrs.hasOwnProperty(attr)) { stop.setAttribute(attr, attrs[attr]); }
          }
          grad.appendChild(stop);
        }

        const defs = svg.querySelector('defs') ||
          svg.insertBefore(document.createElementNS(svgNS, 'defs'), svg.firstChild);
        return defs.appendChild(grad);
      }
    }
  }

  public displayTab(_tabId) { // to refactor - using service product as object
    const active = this.selectedTab;

    if (_tabId !== active) {
      if (_tabId === 'expl') {
        this.selectedTab = 'expl';
      } else if (_tabId === 'case') {
        this.selectedTab = 'case';
      }
    }
  }

  public scroll(target) {
    const el = document.getElementById(target);
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
